import type { AdrStatus, AdrImplementationStatus } from '../types';

export const STATUS_COLORS: Record<AdrStatus, string> = {
  draft: '#9ca3af',
  proposed: '#f59e0b',
  accepted: '#10b981',
  deprecated: '#ef4444',
  superseded: '#f97316',
};

export const IMPL_STATUS_COLORS: Record<AdrImplementationStatus, string> = {
  pending: '#9ca3af',
  in_progress: '#3b82f6',
  done: '#10b981',
  abandoned: '#ef4444',
};
